import { NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
  DialogComponent,
} from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe, AgrDatePipe } from '@next/core-lib/i18n';

import { Store } from '@ngrx/store';

import { SlaughterInvoice } from '../../models/flock-registration-service.model';
import * as cycleActions from '../../store/actions/cycle.actions';

export interface ImportFromSlaughterInvoiceDialogInputData extends AbstractDialogData {
  slaughterInvoices: SlaughterInvoice[];
  cycleId: number;
}

@Component({
  selector: 'app-import-from-slaughter-invoice',
  templateUrl: 'import-from-slaughter-invoice.component.html',
  styleUrls: ['import-from-slaughter-invoice.component.scss'],
  imports: [
    DialogComponent,
    NgFor,
    MatCard,
    MatCardContent,
    MatCheckbox,
    ReactiveFormsModule,
    FormsModule,
    TranslatePipe,
    AgrDatePipe,
  ],
})
export class ImportFromSlaughterInvoiceComponent extends AbstractDialog {
  data = inject<ImportFromSlaughterInvoiceDialogInputData>(MAT_DIALOG_DATA);
  protected mdDialogRef =
    inject<MatDialogRef<ImportFromSlaughterInvoiceComponent, AbstractDialogResultData>>(
      MatDialogRef,
    );
  private readonly store = inject(Store);
  private readonly localeService = inject(LocaleService);

  public readonly selectedInvoiceIds: number[] = this.data.slaughterInvoices.map((i) => i.id);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    super();
    const localeService = this.localeService;

    this.data.confirmButton = true;
    this.data.title = localeService.translate('link-slaughter-invoices-title');
    this.updateConfirmButtonText();
  }

  save() {
    this.store.dispatch(
      cycleActions.linkSlaughterInvoices({
        cycleId: this.data.cycleId,
        ids: this.selectedInvoiceIds,
      }),
    );

    super.confirm();
  }

  updateInvoiceSelection($event: MatCheckboxChange, invoiceId: number) {
    if ($event.checked) {
      this.selectedInvoiceIds.push(invoiceId);
    } else {
      const index = this.selectedInvoiceIds.indexOf(invoiceId);
      if (index > -1) {
        this.selectedInvoiceIds.splice(index, 1);
      }
    }

    this.updateConfirmButtonText();
  }

  private updateConfirmButtonText() {
    this.data.confirmButtonText = `${this.localeService.translate('import')} (${
      this.selectedInvoiceIds.length
    })`;
    this.data.disableConfirmButton = this.selectedInvoiceIds.length === 0;
  }
}
